<div class="error-bg"></div>
<div class="account-pages">

  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-8">
        <div class="card shadow-lg">
          <div class="card-block">
            <div class="text-center p-3">

              <h1 class="error-page mt-4"><span>404!</span></h1>
              <h4 class="mb-4 mt-5">Sorry!!, <b>página no encontrada</b></h4>
              <p class="mb-4">La ruta o la página que estas buscando no ha sido encontrada
              </p>
              <a class="btn btn-primary mb-4 waves-effect waves-light"
               routerLink="/admin/sucursales"><i class="mdi mdi-home"></i>
                Regresar a página principal
            </a>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</div>
